import { Box, Typography } from '@mui/material';
import { ArsatLogo } from './ArsatLogo';
import { useRouter } from 'next/router';
import { flexCenter, flexColumn } from '@utils/utility-classes';

const LoginLayout = ({ children }) => {
  const router = useRouter();
  const { debug } = router.query;
  return (
    <Box
      sx={{
        ...flexCenter,
        bgcolor: { xs: '#fff', sm: debug ? '#535554' : 'common.blue' },
        height: '100vh',
        minHeight: 420,
      }}
    >
      <Box
        sx={{
          ...flexColumn,
          alignItems: 'center',
          bgcolor: '#fff',
          borderRadius: 4,
          p: '70px 20px 40px',
          maxWidth: '100%',
          width: 550,
        }}
      >
        <ArsatLogo height={35} width={200} />
        <Typography
          sx={{
            color: 'primary.light',
            display: 'flex',
            justifyContent: 'center',
            fontSize: 30,
            mt: 3.25,
          }}
        >
          {debug ? 'DEBUG' : '¡Hola!'}
        </Typography>
        {children}
      </Box>
    </Box>
  );
};

export default LoginLayout;
